import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { toDisplayStatus } from '../../utils/extractionUtils';
import { Text, TranslatedString, useTranslation } from '../blocks/localization';
import { HelpPopover } from '../constructed';
import { StatusInProgress, StatusNegative, StatusPositive, StatusWarning } from '../icons';

type ExtractionStatusIconProps = {
    status?: string;
    errorCode?: string;
    extractionId?: string;
    inheritColor?: boolean;
};

export const ExtractionStatusIcon: FC<ExtractionStatusIconProps> = ({
    status,
    errorCode,
    extractionId,
    inheritColor = false,
}) => {
    const { t } = useTranslation('extractionStatus');
    const displayStatus = toDisplayStatus(status);
    const text: TranslatedString = t('extractionStatus-value', { context: displayStatus });
    const errorMessage: TranslatedString = errorCode
        ? t.expression(`error-${errorCode}`, { defaultValue: t('error-generic') })
        : t('error-generic');

    const determineIcon = () => {
        switch (displayStatus) {
            case 'CREATED':
                return <StatusPositive />;
            case 'DRAFT':
                return <StatusWarning />;
            case 'FAILED':
                return <StatusNegative />;
            default:
                return <StatusInProgress />;
        }
    };

    return (
        <Row width={'100%'}>
            {determineIcon()}
            {inheritColor ? <span>{text}</span> : <Text>{text}</Text>}
            {displayStatus === 'FAILED' && (
                <HelpPopover header={t('error-popoverTitle')} dataTestId={'extractionError'}>
                    <Column spacing={'small'}>
                        <Text>{errorMessage}</Text>
                        {/* The only identifier support can look a failed extraction up by: the
                            reference number and file name are often empty when extraction fails. */}
                        {extractionId && <Text type={'b200'}>{t('error-extractionId', { extractionId })}</Text>}
                    </Column>
                </HelpPopover>
            )}
        </Row>
    );
};
